import { render } from "./UserMenu.vue?vue&type=template&id=a5313e0a&lang=pug"
import script from "./UserMenu.vue?vue&type=script&lang=js"
export * from "./UserMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/topBar/UserMenu.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a5313e0a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a5313e0a', __exports__)) {
    api.reload('a5313e0a', __exports__)
  }
  
  module.hot.accept("./UserMenu.vue?vue&type=template&id=a5313e0a&lang=pug", () => {
    api.rerender('a5313e0a', render)
  })

}


export default __exports__